<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row mt-3">
                <div class="col-md-12 text-right">
                    <b-button variant="success" size="sm" title="Adicionar PDV" @click.prevent="novoPDV">
                        <i class="fa fa-plus"></i> Adicionar Ponto de Venda
                    </b-button>
                </div>
            </div>
            <b-row class="mt-2">
                <b-table :items="dataComputed" :fields="colunas" stacked="md" show-empty
                    empty-text="Nenhum Ponto de Venda Encontrado" small striped :busy="loading">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Buscando PDVs...</strong>
                        </div>
                    </template>
                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" @click="edit(row.item.id)" class="mr-1">
                            <i class="fas fa-edit"></i>
                        </b-button>

                    </template>
                </b-table>
            </b-row>

            <!-- <v-table :column="colunas" :data="dataComputed" :actions="actionsTable" @edit='edit'></v-table> -->

            <!-- **************** Início Modais ****************** -->

            <div id="createModal" class="modal fade">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content modal-lg">
                        <div class="modal-header">
                            <h4 class="modal-title" v-if="criar"> Criar Ponto de Venda</h4>
                            <h4 class="modal-title" v-if="!criar"> Alterar Ponto de Venda {{ nome }}</h4>

                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" style="width: 800px;">
                            <div class="row">

                                <!-- <ul class="nav nav-pills nav-justified">
                                    <a href="#first-tab" data-toggle="tab">
                                        <b-button primary>Dados</b-button>
                                    </a>
                                    <a href="#second-tab" data-toggle="tab">
                                        <b-button primary>Contatos</b-button>
                                    </a>
                                </ul>-->
                                <div class="card" style="width: 800px;">
                                    <b-tabs content-class="mt-3" pills fill justified align="center">
                                        <!-- ******************* Dados ********************* -->
                                        <b-tab active title="Dados" id="first-tab">
                                            <div class="row g-0">
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label for="">Nome </label>
                                                        <input type="text" class="form-control" v-model="nome">
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">CPF </label>
                                                        <input type="text" @input="validarCPF" v-mask="'###.###.###-##'" placeholder="000.000.000-00" class="form-control" v-model="cpf">
                                                        <p v-if="cpfIsValid === false" class="text-danger">
                                                            CPF Inválido
                                                        </p>
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Email</label>
                                                        <input type="email" class="form-control" v-model="email">
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Código PDV</label>
                                                        <input type="text" class="form-control" v-model="cod_pdv"
                                                            maxlength="8">
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Senha de acesso</label>
                                                        <input type="password" class="form-control" v-model="senha_pdv">
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Confirmar Senha</label>
                                                        <input type="password" class="form-control"
                                                            v-model="senha_pdv_confirm">
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Status</label>
                                                        <select name="" id="" class="form-control" v-model="status">
                                                            <option :value="1">Ativo</option>
                                                            <option :value="0">Inativo</option>
                                                        </select>
                                                    </div>

                                                </div>

                                                <div class="col-md-6">

                                                    <div class="form-group">
                                                        <label for="">CEP</label>
                                                        <input type="text" class="form-control" v-model='cep'
                                                            v-mask="'## ###-###'" @keyup="buscacep">
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Estado</label>
                                                        <select name="" id="" class="form-control" v-model="estado"
                                                            @change="getCidades" disabled="">
                                                            <option value="-1" disabled="">Selecione Estado</option>
                                                            <option :value="estado.uf"
                                                                v-for="(estado, index) in estados" :key="index">
                                                                {{ estado.nome }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="">Cidade</label>
                                                        <select name="" id="" class="form-control" v-model="cidade"
                                                            disabled="">
                                                            <option value="-1" disabled="">Selecione Cidade</option>
                                                            <option :value="cidade.ibge"
                                                                v-for="(cidade, index) in cidades" :key="index">
                                                                {{ cidade.nome }}</option>
                                                        </select>
                                                    </div>

                                                    <div class="form-group">
                                                        <label for="">Logradouro</label>
                                                        <input type="text" class="form-control" v-model="logradouro">
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="">Bairro</label>
                                                        <input type="text" class="form-control" v-model="bairro">
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="">Complemento</label>
                                                        <input type="text" class="form-control" v-model="complemento">
                                                    </div>
                                                </div>
                                            </div>
                                        </b-tab>
                                        <!-- ************** Contatos **************************** -->
                                        <b-tab id="second-tab" title="Contatos">
                                            <div class="col-md-12">
                                                <table class="table table-responsive ">
                                                    <tbody>
                                                        <button class="btn btn-success text-right" @click="addContato">
                                                            <i class="fa fa-plus"></i> Contato</button>
                                                        <tr v-for="(contato, index) in contatos" :key="index">
                                                            <td>
                                                                <div class="form-group ">
                                                                    <label for="">Tipo</label>
                                                                    <select name="" id="" class="form-control"
                                                                        v-model='contato.tipo'>
                                                                        <option value="F">Fixo</option>
                                                                        <option value="M">Móvel</option>
                                                                    </select>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group ">
                                                                    <label for="">Numero</label>
                                                                    <input type="text" class="form-control"
                                                                        v-mask="['(##) ####-####', '(##) #####-####']"
                                                                        v-model="contato.numero">

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group ">
                                                                    <label for="">Whatsapp</label>
                                                                    <select name="" id="" class="form-control"
                                                                        v-model="contato.whatsapp">
                                                                        <option :value="0">Não</option>
                                                                        <option :value="1">Sim</option>
                                                                    </select>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group ">
                                                                    <p class="btn-remove-contato">
                                                                        <button class="btn btn-danger"
                                                                            @click="removeContato(index)"><i
                                                                                class="fas fa-trash-alt"></i></button>
                                                                    </p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                    <div class="hide-footer text-right mb-2">
                                        <b-button class="mr-3" variant="primary" size="sm" @click="savePDV">
                                            <i class="fa fa-save"></i> Salvar
                                        </b-button>
                                        <b-button class="mr-3" variant="secondary" size="sm"
                                            data-dismiss="modal">Cancelar
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    data() {

        return {
            
            loading: false,
            colunas: [
                { key: 'actions', label: '' },
                { key: 'codigo', label: 'Código' },
                { key: 'nome', label: 'Nome' },
                { key: 'status', label: 'Status' },
                { key: 'cidade', label: 'Cidade' },
            ],
            actionsTable: ['edit'],
            tableData: [],
            estados: [],
            cidades: [],
            estado: -1,
            cidade: -1,
            nome: "",
            email: "",
            cep: "",
            logradouro: "",
            bairro: "",
            complemento: "",
            cod_pdv: '',
            cpf: "",
            cpfIsValid: null,
            senha_pdv: '',
            senha_pdv_confirm: "",
            contatos: [{
                tipo: "F",
                numero: "",
                whatsapp: 0
            },],
            status: 1,
            criar: true, //Indentificar se está criando ou alterando um PDV
            id: -1

        }
    },
    methods: {
        validarCPF(cpf) {
            cpf = cpf.target.value.replace(/[^\d]+/g, '');

            if (cpf.length === 0) {
                this.cpfIsValid = null;
                return;
            }

            if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
                this.cpfIsValid = false;
            }

            let soma = 0;
            let resto;

            for (let i = 1; i <= 9; i++) {
                soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
            }
            resto = (soma * 10) % 11;

            if ((resto === 10) || (resto === 11)) resto = 0;
            if (resto !== parseInt(cpf.substring(9, 10))) {
                this.cpfIsValid = false;
            }else{
                this.cpfIsValid = true;
            }

            soma = 0;
            for (let i = 1; i <= 10; i++) {
                soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
            }
            resto = (soma * 10) % 11;

            if ((resto === 10) || (resto === 11)) resto = 0;
            if (resto !== parseInt(cpf.substring(10, 11))){
                this.cpfIsValid = false;
            }else{
                this.cpfIsValid = true;
            }
        },
        loadPDVs() {
            var vm = this;
            $(".loading").show();
            axios("/distribuidor/pdv/listar").then(function (response) {
                vm.formatTablePDVs(response.data);
                $(".loading").hide();
            }).catch(function (error) {
                alert("Falha ao carregar os PDVs");
                console.log(error.response);
                $(".loading").hide();
            });
        },
        formatTablePDVs(pdvs) {
            var listPDV = [];

            pdvs.forEach(function (item) {
                let obj = {};

                obj.id = item.id;

                obj.codigo = item.codigo.replace($("#codigo_distribuidor").val(), "");
                obj.nome = item.nome;
                obj.status = (item.status) ? "Ativo" : "Inativo";
                obj.cidade = item.endereco.cidade.nome;
                listPDV.push(obj);
            });

            this.tableData = listPDV;
        },
        getEstados() {
            var vm = this;
            $('.loading').show();
            axios.get('/estados').then(function (response) {
                vm.estados = response.data;
                $('.loading').hide();
            }).catch(function (error) {
                alert("Erro ao buscar estados");
                console.log(error);
                $('.loading').hide();
            });
        },
        getCidades() {
            var vm = this;
            $('.loading').show();
            axios.get('/cidades/' + this.estado).then(function (response) {
                vm.cidades = response.data;
                $('.loading').hide();
            }).catch(function (error) {
                alert("Erro ao buscar cidades.");
                console.log(error);
                $('.loading').hide();
            });
        },
        buscacep() {
            let numCep = this.cep.replace(/[^0-9]/g, '');

            if (numCep.length != 8) {
                return;
            }
            var vm = this;
            $('.loading').show();
            $.getJSON("//viacep.com.br/ws/" + numCep + "/json/", function (dados) {
                if ("erro" in dados) {
                    alert("Endereço não encontrado");
                    console.log(dados);
                    vm.clearEndereco();
                    $('.loading').hide();
                    return;
                }

                if (dados.uf !== $("#estado_distribuidor").val()) {
                    alert("O PDV não pode pertencer a outro estado.");
                    $('.loading').hide();
                    vm.clearEndereco();
                    return;
                }

                vm.bairro = dados.bairro;
                vm.logradouro = dados.logradouro;
                vm.complemento = dados.complemento;
                vm.cidade = dados.ibge;
                vm.estado = dados.uf;
                vm.getCidades();
                $('.loading').hide();
            });

        },
        novoPDV() {
            this.criar = true;
            this.cleaarForm();
            this.cep = $("#cep_distribuidor").val();
            this.estado = $("#estado_distribuidor").val();
            this.getCidades();
            this.cidade = $("#cidade_distribuidor").val();
            this.logradouro = $("#log_distribuidor").val();
            this.bairro = $("#bairro_distribuidor").val();
            $("#createModal").modal();

        },

        edit(id) {
            var vm = this;
            this.criar = false;
            this.id = -1;
            $('.loading').show();

            axios.get("/distribuidor/pdv/" + id).then(function (response) {
                vm.cleaarForm();
                let pdv = response.data;
                vm.nome = pdv.nome;
                vm.cpf = pdv.cpf;
                vm.cod_pdv = pdv.codigo.replace($("#codigo_distribuidor").val(), "");
                vm.email = pdv.email;
                vm.status = (pdv.status) ? 1 : 0;
                vm.cep = pdv.endereco.cep;
                vm.estado = pdv.endereco.cidade.estado.uf;
                vm.getCidades();
                vm.cidade = pdv.endereco.cidade.ibge;
                vm.complemento = pdv.endereco.complemento;
                vm.logradouro = pdv.endereco.logradouro;
                vm.bairro = pdv.endereco.bairro;
                vm.id = pdv.id;
                var contatos = [];
                pdv.contatos.forEach(function (item) {
                    let obj = {};
                    obj.tipo = item.telefone.tipo;
                    let fone = item.telefone.ddd + "" + item.telefone.numero
                    obj.numero = fone;
                    obj.whatsapp = (item.telefone.whatsapp) ? 1 : 0;
                });

                vm.contatos = contatos;
                $("#createModal").modal();
                $(".loading").hide();
            }).catch(function (error) {
                var errors = error.response.data.errors;
                if (typeof (errors) == "object") {
                    alert(errors.join('\n'));
                } else {
                    alert(errors);
                }
                console.log(error.response);
                $(".loading").hide();
            });
        },
        savePDV() {
            if (!this.validadePDV()) {
                return;
            }
            const vm = this;
            var data = {
                nome: this.nome,
                codigo: this.cod_pdv,
                cpf: this.cpf,
                password: this.senha_pdv,
                password_confirmation: this.senha_pdv_confirm,
                cep: this.cep,
                cidade: this.cidade,
                logradouro: this.logradouro,
                bairro: this.bairro,
                complemento: this.complemento,
                contatos: this.contatos,
                status: this.status,
                estado: this.estado,
                email: this.email
            };
            
            $(".loading").show();
            let url = "/distribuidor/pdv";
            if (!this.criar) {
                url = "/distribuidor/pdv/" + this.id;
                data['_method'] = "PUT";
            }
            axios.post(url, data).then((response) => {
                $("#createModal").modal("hide");
                vm.loadPDVs();
            }).catch((error) => {
                console.log(error.response);
                var errors = error.response.data.errors;
                if (typeof (error.response.data) == 'string') {
                    errors = error.response.data;
                } else if (!errors) {
                    errors = JSON.parse(error.response.data);
                } else {
                    errors = error.response.data.message;
                }
                if (typeof (errors) === "object" || typeof (errors) === 'array') {
                    vm.$swal({
                        title: "Atenção",
                        html: errors.join('\n'),
                        icon: "error",
                    });
                } else {
                    vm.$swal({
                        title: "Atenção",
                        html: errors,
                        icon: "error",
                    });
                }
            }).finally(() => {
                $(".loading").hide();
            });
        },
        validadePDV() {
            if(this.cpf && this.cpfIsValid === false){
                alert('CPF informado é inválido!');
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }

            if (this.nome.length < 5) {
                alert('Nome é Obrigatório com pelo menos 5 letras!');
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }
            if (this.cod_pdv.length === 0) {
                alert("O Código é Obrigatório!");
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }
            if (this.cod_pdv.length > 8) {
                alert("Código deve conter no máximo 8 dígitos e/ou caracteres!");
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }
            if ((!this.criar && this.senha_pdv.length > 0 && this.senha_pdv.length < 6) || (this.criar && this.senha_pdv.length < 6)) {
                alert('Senha deve conter no mínimo 6 caracteres!');
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }
            if ((this.criar && this.senha_pdv !== this.senha_pdv_confirm) || (!this.criar && this.senha_pdv.length > 0 && this.senha_pdv !== this.senha_pdv_confirm)) {
                alert('Senhas não correspondem!');
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }
            if (!this.validateEndereco()) {
                return false;
            }
            return true;
        },
        validateEndereco() {
            if (this.cep.replace(/[^0-9]/g, '').length !== 8) {
                alert('Inform um cep Válido!');
                $(' a[href="#first-tab"]').tab('show');
                return false;
            }
            if (this.bairro.length < 3) {
                alert("Informe o Bairro");
                return false;
            }
            if (this.logradouro.length < 3) {
                alert('Logradouro Obrigatório!');
                return false;
            }
            return true;
        },
        validateContatos() {
            var retorno = true;
            this.contatos.forEach(function (item, index) {
                if (item.numero.replace(/[^0-9]/g, '').length < 10) {
                    alert("Contato " + index + " é inválido!");
                    $(' a[href="#second-tab"]').tab('show');
                    retorno = false;
                }
            }, retorno);
            return retorno;
        },

        addContato() {
            this.contatos.push({
                tipo: "F",
                numero: "",
                whatsapp: 0
            });
        },

        removeContato(index) {
            if (this.contatos.length == 1) {
                alert("O contato é Obrigatório!");
                return;
            }
            this.contatos.splice(index, 1);
        },

        cleaarForm() {
            this.cpfIsValid = null;
            this.nome = "";
            this.email = "";
            this.cep = "";
            this.cpf = "";
            this.cidade = -1;
            this.estado = -1;
            this.logradouro = "",
                this.bairro = "",
                this.complemento = "";
            this.cod_pdv = '';
            this.senha_pdv = '',
                this.senha_pdv_confirm = "";
            this.contatos = [{
                tipo: "F",
                numero: "",
                whatsapp: 0
            },];
            this.rg = "";
        },

        clearEndereco() {
            let vm = this;
            vm.cep = "";
            vm.bairro = "";
            vm.logradouro = "";
            vm.complemento = "";
            vm.cidade = -1;
            vm.estado = -1;
        }
    },
    computed: {
        dataComputed: function () {
            return this.tableData;
        }
    },
    created: function () {
        this.loadPDVs();
        this.getEstados();
    }
}
</script>

<style scoped>
.nav-pills {
    padding: 0px 10px 12px 10px;
}

.btn-remove-contato {
    margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pdv/Main.vue